// extracted by mini-css-extract-plugin
module.exports = {"grey-cool":"#afb1b7","white-full":"#f2f2f2","black-full":"#000","black-dark":"#0c0c0c","container":"news_container__mocFs"};